import React, { Component } from 'react'
import TemplateSettingsManager from '../Manager/TemplateSettingsManager'
import { getLocalisedText } from '../Translate/LanguageManager'
import { HTMLTag } from '../Utilities/HTMLTag'
import { getTextAlign } from './dktable/TableUtility'
import { ApprovalSectionType, CustomApprovalSectionType } from '../Utilities/ApprovalSectionUtility'
import { FONT_SIZE } from '../Constants/Constants'
import Utility, { getFontSizeClass, getVW } from '../Utilities/Utility'
import QRCode from "react-qr-code";

export default class DKCustomApprovalSection extends Component {

    render() {
        var customApprovalSectionSettings = TemplateSettingsManager.getCustomApprovalSectionSettings()
        const approvalList = customApprovalSectionSettings?.sections ?? []

        if (approvalList.length === 0) {
            return <></>
        }
        else {
            return this.renderApprovalTable(approvalList, customApprovalSectionSettings)
        }
    }

    renderApprovalTable(approvalList, customApprovalSectionSettings) {
        let topApprovalList = []
        let bottomApprovalList = []

        approvalList.forEach((element, index) => {
            if(index > 3) {
                bottomApprovalList.push(element)
            }
            else {
                topApprovalList.push(element)
            }
        });

        // Calculate column count: bottom row has companyInfo with colspan=2, top row has authorizedBy with colspan=2
        const hasCompanyInfo = bottomApprovalList.some(el => el.type === CustomApprovalSectionType.companyInfo);
        const hasAuthorizedBy = topApprovalList.some(el => el.type === CustomApprovalSectionType.authorizedBy);
        const bottomRowColumns = hasCompanyInfo ? bottomApprovalList.length + 1 : bottomApprovalList.length;
        const topRowColumns = hasAuthorizedBy ? topApprovalList.length + 1 : topApprovalList.length;
        const totalColumns = Math.max(bottomRowColumns, topRowColumns);
        const columnWidth = (100 / totalColumns).toFixed(2) + '%';

        const topCells = topApprovalList.map((element, index) => {
            return this.renderApprovalTableCell(element, index, columnWidth)
        });

        const bottomCells = bottomApprovalList.map((element, index) => {
            return this.renderApprovalTableCell(element, index, columnWidth)
        });

        return <div id={HTMLTag.APPROVAL_TABLE} className='approval_section break-inside-avoid' style={{
            // paddingBottom: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
        }}>
            <table className='doc-container'>
                <tbody style={{
                    border: '1px solid black',
                }}>
                    <tr className='row-cell'>
                        {topCells}
                    </tr>
                    <tr className='row-cell'>
                        {bottomCells}
                    </tr>
                </tbody>
            </table>
        </div>
    }

    renderApprovalTableCell(element, index, columnWidth) {
        switch (element.type) {
            case CustomApprovalSectionType.bank:
                return this.getItemDetailContainer(element, index, columnWidth)
            case CustomApprovalSectionType.qr:
                return this.getQrContainer(element, index, columnWidth)
            case CustomApprovalSectionType.companySeal:
                return this.renderEmptyCell(element, index, columnWidth)
            case CustomApprovalSectionType.authorizedBy:
                return this.renderSignatoryCell(element, index, columnWidth)
            case CustomApprovalSectionType.companyInfo:
                return this.getItemDetailContainer(element, index, columnWidth)
            case CustomApprovalSectionType.createdBy:
                return this.renderEmptyCell(element, index, columnWidth)
            case CustomApprovalSectionType.preparedBy:
                return this.renderEmptyCell(element, index, columnWidth)
            case CustomApprovalSectionType.checkedBy:
                return this.renderEmptyCell(element, index, columnWidth)

            default:
                return <>no type</>;
        }
    }

    getItemDetailContainer(element, index, columnWidth) {
        const items = element.items ?? []
        let itemsRow = undefined


        if(items.length > 0) {
            itemsRow = items.map(item => {
                return this.getRowValueSection(item)
            });
        }

        const isCompanyInfo = element.type === CustomApprovalSectionType.companyInfo;
        return (
            <td className='cell'
                colSpan={isCompanyInfo ? 2 : undefined}
                style={{
                    textAlign: 'left',
                    width: isCompanyInfo ? undefined : columnWidth,
                    border: '1px solid black',
                    ...this.getAdditionalPropertyByElement(element),
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.props.data.printScale),
                    paddingLeft: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
                    paddingRight: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
                }}>
                <div style={{
                    textAlign: 'left',
                }}>
                    {(element.label &&
                        <text style={{
                            ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.xMedium }, this.props.data.printScale)
                        }}>
                            {getLocalisedText(element.label)}
                        </text>
                    )}
                    {itemsRow}
                </div>
            </td>
        )
    }

    getRowValueSection(element) {
        return <div className="RowDiv"
            style={{
                paddingTop: getVW(Utility.convertToPrintScale(2,this.props.data.printScale)),
                paddingBottom: getVW(Utility.convertToPrintScale(2,this.props.data.printScale)),
                flex: 1,
                width: '-webkit-fill-available'
            }}>
            <text className={"docFontStyle" + getFontSizeClass()}
                style={{
                    color:this.props.data.themeColor,
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular },this.props.data.printScale)
                }}>
                {getLocalisedText(element.label)}
            </text>
            <text className={"docFontStyle" + getFontSizeClass()}
                style={{
                    color:this.props.data.themeColor,
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular },this.props.data.printScale)
                }}>
                :
            </text>
            &nbsp;
            <text className={"docFontStyle" + getFontSizeClass()}
                style={{
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular },this.props.data.printScale)
                }}>
                {element.value}
            </text>
        </div>
    }

    getQrContainer(element, index, columnWidth) {
        return (
            <td className='cell' style={{
                textAlign: 'left',
                width: columnWidth,
                border: '1px solid black',
                ...this.getAdditionalPropertyByElement(element),
                ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.props.data.printScale),
                padding: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
            }}>
                {this.renderQRCode(element.value, index)}
            </td>
        )
    }

    renderQRCode(value, index) {
        if (this.getIsContainQRCode(value)) {
            return <QRCode
                id={HTMLTag.QR_CODE_PREFIX + index}
                value={value}
                size={100}
            />
        }
        return null
    }

    getIsContainQRCode(value) {
        if (value !== undefined && value !== null && value.trim().length > 0) {
            return true
        }
        return false
    }

    renderEmptyCell(element, index, columnWidth) {
        const value = this.getItemValue(element);
        return (
            <td className='cell' style={{
                textAlign: getTextAlign(TemplateSettingsManager.getApprovalSectionSettings()?.textAlign),
                color: this.getHeaderColor(),
                border: '1px solid black',
                width: columnWidth,
                ...this.getAdditionalPropertyByElement(element),
                ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.props.data.printScale),
                paddingLeft: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
                paddingRight: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    minHeight: getVW(Utility.convertToPrintScale(80, this.props.data.printScale))
                }}>
                    <div style={{
                        ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.props.data.printScale),
                        fontWeight: 'bold',
                        marginBottom: getVW(Utility.convertToPrintScale(5, this.props.data.printScale))
                    }}>
                        {getLocalisedText(element.label)}
                    </div>
                    <div style={{
                        ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.props.data.printScale),
                        marginTop: getVW(Utility.convertToPrintScale(20, this.props.data.printScale)),
                        minHeight: getVW(Utility.convertToPrintScale(40, this.props.data.printScale)),
                        borderTop: '1px solid black',
                        paddingTop: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
                        width: '100%',
                        textAlign: 'center'
                    }}>
                        {value || ''}
                    </div>
                </div>
            </td>
        )
    }

    renderSignatoryCell(element, index, columnWidth) {
        return (
            <td className='cell docFontStyleBold' colSpan={2} style={{
                textAlign: 'center',
                color: this.getHeaderColor(),
                border: '1px solid black',
                ...this.getAdditionalPropertyByElement(element),
                ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular }, this.props.data.printScale),
                paddingLeft: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
                paddingRight: getVW(Utility.convertToPrintScale(5, this.props.data.printScale)),
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '100%',
                    minHeight: getVW(Utility.convertToPrintScale(120, this.props.data.printScale)),
                    width: '100%',
                }}>
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                    }}>
                        {getLocalisedText(Utility.getCompanyName(this.props.data))}
                    </div>
                    <div style={{
                        textAlign: 'center',
                        width: '100%',
                    }}>
                        {getLocalisedText(element.label)}
                    </div>
                </div>
            </td>
        )
    }

    getAdditionalPropertyByElement(element) {
        switch (element.type) {
            case CustomApprovalSectionType.bank:
                return { verticalAlign: 'top', textAlign: 'center' }
            case CustomApprovalSectionType.qr:
                return { verticalAlign: 'center', textAlign: 'center' }
            case CustomApprovalSectionType.companySeal:
                return { verticalAlign: 'bottom', textAlign: 'center' }
            case CustomApprovalSectionType.authorizedBy:
                return { verticalAlign: 'top', textAlign: 'center' }
            case CustomApprovalSectionType.companyInfo:
                return { verticalAlign: 'top', textAlign: 'center' }
            case CustomApprovalSectionType.createdBy:
                return { verticalAlign: 'top', textAlign: 'center', fontWeight: 'bold' }
            case CustomApprovalSectionType.preparedBy:
                return { verticalAlign: 'top', textAlign: 'center', fontWeight: 'bold' }
            case CustomApprovalSectionType.checkedBy:
                return { verticalAlign: 'top', textAlign: 'center', fontWeight: 'bold' }
            default:
                return { verticalAlign: 'bottom', textAlign: 'center' }
        }
    }

    getApprovalItemFormat(item, position, lineSpace) {
        let htmlString = ''
        const value = this.getItemValue(item) ?? ''

        const defaultLineCount = lineSpace ?? 0
        let lineCount = defaultLineCount

        if (defaultLineCount > 0 && value !== '') {
            lineCount--
        }

        const newLineBreak = new Array(lineCount).fill('<br/>')

        if (position === 'top') {
            htmlString += getLocalisedText(item.label)
            htmlString += '<br/>'
            htmlString += newLineBreak.join('')
            if (value !== '') {
                htmlString += value
            }
        }
        else if (position === 'bottom') {
            if (value !== '') {
                htmlString += value + '<br/>'
            }
            htmlString += newLineBreak.join('')
            htmlString += getLocalisedText(item.label)
        }

        return htmlString
    }

    getItemValue(item) {
        switch (item.type) {
            case ApprovalSectionType.createdBy:
                return this.props.data.createdBy ?? ''
            case CustomApprovalSectionType.createdBy:
                return this.props.data.createdBy ?? ''
            case ApprovalSectionType.checkedBy:
                return this.props.data.checkedBy ?? ''
            case CustomApprovalSectionType.checkedBy:
                return this.props.data.checkedBy ?? ''
            case ApprovalSectionType.authorizedBy:
                return this.props.data.approvedBy ?? ''
            case CustomApprovalSectionType.authorizedBy:
                return this.props.data.approvedBy ?? ''
            case CustomApprovalSectionType.preparedBy:
                return this.props.data.createdBy ?? ''
            default:
                return ''
        }
    }

    getHeaderColor() {
        if (this.props.isThemeColor) {
            return this.props.data.themeColor
        }

        if (this.props.headerColor !== undefined) {
            return this.props.headerColor
        }

        return undefined
    }
}
